const parseBudgetedHours = (value) => {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return null;
  }

  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : null;
};

const hasBudgetedHours = (value) => parseBudgetedHours(value) !== null;

const formatBudgetedHours = (value, unitLabel = 'hrs') => {
  const hours = parseBudgetedHours(value);
  return hours === null ? '' : `${hours} ${unitLabel}`;
};

module.exports = {
  parseBudgetedHours,
  hasBudgetedHours,
  formatBudgetedHours,
};
